module.exports = __webpack_public_path__ + "static/media/18.54e776c4.svg";